import { injectGlobal } from "styled-components";

injectGlobal`  
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  img {
    max-width: 100%;
    height: auto;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global.js